module.exports = __webpack_public_path__ + "img/sea.5a11ba9e.svg";